<template>
  <div class="mt-15 border-t pt-8" v-if="!isPublic && !isAdminRoute && !isAuthRoute">
    <div class="w-full px-4">
      <div class="flex flex-wrap">
        <div class="w-full md:w-1/4">
          <p>©2026 <a href="https://visa.renatello.com/">Unicorn Visa</a></p>
        </div>
      </div>

    </div><!-- container end -->

  </div><!-- wrapper end -->

</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    isPublic () {
      return this.$route.name && this.$route.name.startsWith('public')
    },
    isAdminRoute () {
      return this.$route.name && this.$route.name.startsWith('admin')
    },
    isAuthRoute () {
      const name = this.$route.name
      return name && (name === 'login' || name === 'register' || name === 'reset')
    }
  }
}
</script>
